import { render, staticRenderFns } from "./El_Services.vue?vue&type=template&id=4deef182&scoped=true"
import script from "./El_Services.vue?vue&type=script&lang=js"
export * from "./El_Services.vue?vue&type=script&lang=js"
import style0 from "./El_Services.vue?vue&type=style&index=0&id=4deef182&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4deef182",
  null
  
)

export default component.exports